import { DetailQuery_moment_cards_GifCard } from 'graphql/query/__generated__/DetailQuery';
import styled from 'styled-components/macro';

interface Props {
    card: DetailQuery_moment_cards_GifCard;
    className?: string;
}

export const GIFCard = (props: Props): JSX.Element => {
    if (!props.card.gif.gifUrl) return <></>;

    return (
        <S_GIFCard className={props.className}>
            <S_Image $url={props.card.gif.gifUrl} />
        </S_GIFCard>
    );
};

const S_GIFCard = styled.div`
    display: flex;
    justify-content: center;
`;

const S_Image = styled.div<{ $url: string }>`
    background-color: #e4e4e4;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    background-image: url(${(props) => props.$url});
    width: 250px;
    height: 250px;
`;
